import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import NavigationMenuItem from "./NavigationMenuItem";
import { IconButton } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import withIntl from "../../utils/withIntl";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    position: "absolute",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
}));

function NestedSidebar(props) {
  const classes = useStyles();
  const [selectedLinkWithSubLinks, setSelectedLinkWithSubLinks] = React.useState(props.selectedLinkWithSubLinks);
  const [isSubDrawerOpen, setIsSubDrawerOpen] = React.useState(props.subDrawerOpen);

  if (selectedLinkWithSubLinks !== props.selectedLinkWithSubLinks) {
    setSelectedLinkWithSubLinks(props.selectedLinkWithSubLinks);
    setIsSubDrawerOpen(false);
  }
  if (selectedLinkWithSubLinks === props.selectedLinkWithSubLinks && isSubDrawerOpen !== props.subDrawerOpen) {
    setIsSubDrawerOpen(props.subDrawerOpen);
  }

  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="right"
      open={isSubDrawerOpen}
      classes={{
        paper: classes.drawerPaper,
        paperAnchorLeft: classes.paperAnchorLeft,
      }}
      style={{ width: "240px" }}
      onMouseLeave={() => {
        props.setSubDrawerOpen(false);
      }}
    >
      <div className={classes.drawerHeader}>
        {props.smallScreen && (
          <IconButton onClick={() => props.setSubDrawerOpen(false)}>
            <ChevronLeftIcon />
          </IconButton>
        )}
        {props.selectedLinkWithSubLinks && (
          <ListItemText primary={props.intl.formatMessage({ id: props.selectedLinkWithSubLinks.name })} />
        )}
      </div>
      <Divider />
      <List>
        {props.selectedLinkWithSubLinks?.subLinks.map((link) => {
          return (
            <NavigationMenuItem
              link={link}
              onClick={(e) => {
                props.navigationMenuItemSelected(e);
              }}
              onMouseOver={() => {}}
            />
          );
        })}
      </List>
    </Drawer>
  );
}

export default withIntl(NestedSidebar);
